import { render, staticRenderFns } from "./AulaBadge.vue?vue&type=template&id=01673b2a&scoped=true&"
var script = {}
import style0 from "./AulaBadge.vue?vue&type=style&index=0&id=01673b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01673b2a",
  null
  
)

export default component.exports